module.exports = __webpack_public_path__ + "media/images/ioscor-web-logo-19127e266f3254160453c573a3dacb2b.png";